export const getSource = (item, attr = 'link') => (item.file ? URL.createObjectURL(item.file) : item[attr]);

export const getExtension = (item, attr = 'link') => {
  const link = item?.file ? item?.file.name : item[attr];
  if (!link) {
    return null;
  }
  return link.split('.').slice(-1).pop().split('?')?.[0];
};

export const getExtensionSigned = (item, attr = 'link') => {
  const link = item?.file ? item?.file.name : item[attr];
  return link.split('?')?.[0]?.split('.').slice(-1).pop();
};

export const getFromBlobFileExtension = (url, contentType) => {
  const urlMatch = url.match(/\.([a-zA-Z0-9]+)(\?|$)/);
  if (urlMatch) return urlMatch[1].toLowerCase();

  if (contentType) {
    const typeMap = {
      'image/jpeg': 'jpg',
      'image/jpg': 'jpg',
      'image/png': 'png',
      // 'image/gif': 'gif',
      'application/pdf': 'pdf'
      // 'application/msword': 'doc',
      // 'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx'
    };
    return typeMap[contentType] || null;
  }

  return null;
};
